export default "__VITE_ASSET__BbT0VGF5__"